"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const Navbar_1 = __importDefault(require("../Navbar"));
const Home = () => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Navbar_1.default, {}), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'app-dashboard' }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'home-page' }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) })) }))] }));
};
exports.default = Home;
